import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useFetch } from '../useFetch'

import { CONFIG } from '../../config'
import { ForgotCredentials } from '../../types/user/auth'
import { ApiError } from '../../types/exception/errorStatus'
import { getErrorMessage } from '../../utils/exception/exceptionUtils'

export function useForgotPassword() {
  const { t } = useTranslation(['auth', 'exceptions'])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [success, setSuccess] = useState<string | null>(null)
  const { poster } = useFetch()

  const resetState = () => {
    setLoading(false)
    setError(null)
    setSuccess(null)
  }

  const sendResetLink = async (
    resetCredentialsRequest: ForgotCredentials
  ) => {
    setLoading(true)
    try {
      await poster(
        `${CONFIG.BOUNCE_API}/api/v1/account/password/reset-request`,
        resetCredentialsRequest,
        'application/json'
      )
      setSuccess(t('auth:password.sent-email-successfully'))
      setError(null)
    } catch (error) {
      console.log(error)
      if (error instanceof ApiError) {
        const translatedMessage = getErrorMessage(error.data)
        setError(translatedMessage)
      } else setError(t('exceptions:unknown'))
    } finally {
      setLoading(false)
    }
  }
  return { sendResetLink, loading, error, success, resetState }
}
